module.exports = {
	accountErrors:{
		updateEmail:{
			'412':'The password you entered was incorrect',
			'409':'An account with that email already exists',
			'422':'User has google ID, email can not be updated'//should be blocked by UI
		},
		updatePassword:{
			'412':'The existing password you entered was incorrect',
		},
		addGoogleSignin:{
			'409':'This Google account is already linked with another Plickers account.',
			'412':'The password you entered was incorrect',
			'422':'The Google account email does not match your existing Plickers email. Please try again with a matching Google account.'
		},
		removeGoogleSignin:{
			'412':'The password you entered was incorrect',
			'422':'Cant remove as google signin is the only menthod available'//should be blocked by UI
		},
		updateGoogleSignin:{
			'409':'New Google account is already in use with another Plickers account',
			'412':'Authentication failed. Please make sure "Current Google Sign-In" is the one linked to Plickers account.'//should be blocked by UI
		},
		addPassword:{
			'409':'User already has password setup', //should be blocked by UI
			'412':'Authentication failed. Please make sure to use the google account linked to Plickers account',
		}
	}
}




// WEBPACK FOOTER //
// ./src/errorMessages.js